import { noop } from 'lodash'
import { eventCreator } from './events'
import appApiCreator from './api'
import { createPublicApi } from './public-api'

const createModuleFactories = async services => {
  const { editorSdkProxy, logger, finalAppApiPromise } = services

  finalAppApiPromise.then(async appApi => {
    try {
      await appApi.refreshControllersState()
    } catch (error) {
      logger.error(
        new Error('Failed to refresh controllers state on initialization', {
          cause: error,
        }),
      )
    }
  })

  editorSdkProxy.addEventListener('componentAddedToStage', noop)
  editorSdkProxy.addEventListener('componentSelectionChanged', noop)
  editorSdkProxy.addEventListener('undo', noop)
  editorSdkProxy.addEventListener('redo', noop)
  editorSdkProxy.addEventListener('siteLanguageChanged', noop)

  return {
    getModuleName: () => 'data-binding',
    createAppApi: () => appApiCreator({ ...services }),
    createEventHandlers: ({ appApi }) => eventCreator({ ...services, appApi }),
  }
}

const publicApi = createPublicApi()

export default { createModuleFactories, publicApi }
